import { useEffect, useState } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { onChallenge } from "@/lib/challenge";

export const ChallengeHost = () => {
  const { config } = useAuth();
  const [req, setReq] = useState(null);
  useEffect(() => onChallenge(setReq), []);
  const close = (ok, token) => {
    if (!req) return;
    ok ? req.resolve(token) : req.reject(new Error("challenge cancelled"));
    setReq(null);
  };
  const siteKey = config?.turnstile_site_key;
  return (
    <Dialog open={!!req} onOpenChange={(o) => !o && close(false)}>
      <DialogContent data-testid="challenge-dialog" className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-primary" />Quick security check</DialogTitle>
          <DialogDescription>We noticed unusual activity. Confirm you're human to continue.</DialogDescription>
        </DialogHeader>
        <div className="flex justify-center py-2" data-testid="challenge-widget">
          {siteKey ? (
            <Turnstile siteKey={siteKey} options={{ theme: "auto" }} onSuccess={(t) => close(true, t)} onError={() => close(false)} onExpire={() => close(false)} />
          ) : (
            <p className="text-sm text-muted-foreground">Security check unavailable. Please wait a few minutes and retry.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
